import { render } from "./TraineeChooseEvaluationModal.vue?vue&type=template&id=8ec2b6e8&scoped=true"
import script from "./TraineeChooseEvaluationModal.vue?vue&type=script&lang=js"
export * from "./TraineeChooseEvaluationModal.vue?vue&type=script&lang=js"

import "./TraineeChooseEvaluationModal.vue?vue&type=style&index=0&id=8ec2b6e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec2b6e8"]])

export default __exports__